// src/components/SEO/HomeHelmetComponent.jsx
import { Helmet } from "react-helmet-async";

function HomeHelmetComponent() {
  return (
    <Helmet>
      {/* Perusasetukset */}
      <html lang="fi" className="dark" />
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index,follow" />
      <meta name="theme-color" content="#3B0273" />
      <link
        rel="icon"
        href="/wp-content/themes/spiderlegsproductions-theme/favicon.ico"
      />

      {/* SEO */}
      <title>
        Spiderlegs Productions | Tapahtumatekniikka ja laitevuokraus
      </title>
      <meta
        name="description"
        content="Spiderlegs Productions tarjoaa tapahtumatekniikkaa ja laitevuokrausta juhliin, yritystapahtumiin ja tilaisuuksiin. Äänentoisto, valaistus ja tekninen toteutus Etelä-Suomessa."
      />
     
      {/* (Valinnainen) keywords */}
      <meta
        name="keywords"
        content="tapahtumatekniikka, laitevuokraus, äänentoiston vuokraus, valaistus vuokraus, tapahtumatuotanto, juhlatekniikka, yritystapahtumat, Spiderlegs Productions"
      />

      {/* Open Graph / Facebook */}
      <meta property="og:locale" content="fi_FI" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spiderlegs Productions" />
      <meta
        property="og:title"
        content="Spiderlegs Productions | Tapahtumatekniikka ja laitevuokraus"
      />
      <meta
        property="og:description"
        content="Tapahtumatekniikkaa ja laitevuokrausta juhliin ja yritystapahtumiin. Äänentoisto, valaistus ja tekninen toteutus – Spiderlegs Productions."
      />
      <meta property="og:url" content="https://spiderlegsproductions.com/" />
      <meta
        property="og:image"
        content="https://spiderlegsproductions.com/assets/spiderlegs_productions_og_image.png"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="fb:app_id" content="1084949286986176" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Spiderlegs Productions | Tapahtumatekniikka ja laitevuokraus"
      />
      <meta
        name="twitter:description"
        content="Tapahtumatekniikkaa ja laitevuokrausta juhliin ja yritystapahtumiin. Äänentoisto, valaistus ja tekninen toteutus."
      />
      <meta
        name="twitter:image"
        content="https://spiderlegsproductions.com/assets/spiderlegs_productions_og_image.png"
      />

      {/* Verifications */}
      <meta
        name="google-site-verification"
        content="BSPXgxOB73EGVP-E9a8zPahdcltnK6fnZX1_3PkXRec"
      />

      {/* Fontit */}
      <link
        rel="preconnect"
        href="https://fonts.googleapis.com"
        crossOrigin=""
      />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin=""
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Outfit:wght@100;300;400;500;600;700&family=Bebas+Neue&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}

export default HomeHelmetComponent;
